// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"170292da","729":"d17a4686","977":"839062e3"}[chunkId] + ".chunk.js";
};